export default __webpack_public_path__ + "static/media/Mario.9e37a3c8.mp3";